import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {
    ChangePassword,
    CreateClinic,
    Connections,
    CreateLab,
    CreateUser,
    CaseDetails,
    CasesDashboard,
    Dashboard,
    Login,
    NotFound,
    NotProtectedRoute,
    ProtectedRoute,
    Clinics,
    HealthReportViewer,
    Labs,
    Users,
    RegisterLab,
    RegisterClinic,
    // Profile,
    // Register,
    // PasswordRecovery,
    PasswordReset,
    RedirectIfLoggedInRoute,
    // Connections,
} from './routes';

function App() {
    return (
        <Router>
            <Routes>
                <Route element={<NotProtectedRoute />}>
                    <Route path="/health-report/:id" element={<HealthReportViewer />} />
                </Route>
                <Route element={<RedirectIfLoggedInRoute />}>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    {/* These are probably in the wrong group and will need to be moved someday. */}
                    <Route path="/register-lab" element={<RegisterLab />} />
                    <Route path="register-clinic" element={<RegisterClinic />} />
                    <Route path="/password-reset" element={<PasswordReset />} />
                </Route>
                {/* <Route path="/password-recovery" element={<PasswordRecovery />} /> */
                /* <Route path="/register" element={<Register />} /> */}
                <Route element={<ProtectedRoute />}>
                    <Route path="*" element={<NotFound />} />
                </Route>
                <Route element={<ProtectedRoute rule="cases:read" />}>
                    <Route path="/cases" element={<CasesDashboard />} />
                    <Route path="/cases/:caseId" element={<CaseDetails />} />
                </Route>
                <Route element={<ProtectedRoute rule="users:write" />}>
                    <Route path="/create-user" element={<CreateUser />} />
                </Route>
                <Route element={<ProtectedRoute rule="clinics:write" />}>
                    <Route path="/create-clinic" element={<CreateClinic />} />
                </Route>
                <Route element={<ProtectedRoute rule="labs:write" />}>
                    <Route path="/create-lab" element={<CreateLab />} />
                </Route>
                <Route element={<ProtectedRoute rule="connections:read" />}>
                    <Route path="/connections" element={<Connections />} />
                </Route>
                <Route element={<ProtectedRoute rule="profile" />}>
                    <Route path="/change-password" element={<ChangePassword />} />
                </Route>
                <Route element={<ProtectedRoute rule="clinics:write" />}>
                    <Route path="/clinics" element={<Clinics />} />
                </Route>
                <Route element={<ProtectedRoute rule="analytics:read" />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                </Route>
                <Route element={<ProtectedRoute rule="labs:write" />}>
                    <Route path="/labs" element={<Labs />} />
                </Route>
                <Route element={<ProtectedRoute rule="users:write" />}>
                    <Route path="/users" element={<Users />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
